/**
 * Recently viewed cards: price, labels, optional quick shop, add-to-cart / select options.
 * Loads after theme.js; overrides theme.buildProductGridItem (used only by RecentlyViewed).
 */
(function () {
  if (!window.theme || typeof theme.buildProductImage !== 'function') {
    return;
  }

  function formatCents(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  theme.buildProductGridForm = function (product) {
    const addLabel =
      (theme.strings && theme.strings.addToCart) || 'Add to cart';
    const selectLabel =
      (theme.strings && theme.strings.selectOptions) || 'Select options';
    const safeAttr = function (s) {
      return String(s == null ? '' : s).replace(/"/g, '&quot;');
    };

    if (product.variants.length === 1) {
      const v = product.variants[0];
      const soldOut =
        (theme.strings && theme.strings.soldOut) || 'Sold out';
      const canBuy = v.available !== false;
      const hiddenId = `
            <input type="hidden" name="id" value="${v.id}">
            <input type="hidden" name="quantity" value="1">`;
      let btnAttrs = `type="submit" name="add" data-add-to-cart class="btn btn--full add-to-cart"`;
      if (!canBuy) {
        btnAttrs += ` disabled="disabled" data-sold-out-atc aria-disabled="true"`;
      }
      return `
        <div class="add-product__btn small--show add-product__btn atcboxpcard">
          <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-single__form product-single__form--recently-viewed" enctype="multipart/form-data">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            ${hiddenId}
            <button ${btnAttrs}>
              <span data-add-to-cart-text data-default-text="${safeAttr(addLabel)}">${canBuy ? addLabel : soldOut}</span>
            </button>
          </form>
        </div>`;
    }

    return `
      <div class="add-product__btn small--show">
        <a href="${product.url}" class="btn btn--full add-to-cart product-option__form">${selectLabel}</a>
      </div>`;
  };

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSizes) {
    let output = '';
    const allLabels = (theme.settings.productLabels || [])
      .map(function (l) {
        return String(l).trim();
      })
      .filter(function (l) {
        return l.length > 0;
      });
    const regularLabel =
      (theme.strings && theme.strings.regularPrice) || 'Regular price';
    const saleLabel =
      (theme.strings && theme.strings.salePrice) || 'Sale price';
    const priceFromTpl =
      (theme.strings && theme.strings.priceFromTemplate) || 'from __PRICE__';

    items.forEach(function (product) {
      const form = theme.buildProductGridForm(product);
      const image = theme.buildProductImage(product, imageSizes);
      const comparePrice = `
        <span class="visually-hidden">${regularLabel}</span>
        <span class="grid-product__price--original">${formatCents(product.compare_at_price)}</span>
        <span class="visually-hidden">${saleLabel}</span>`;

      const tags = (product.tags || [])
        .map(function (tag) {
          const tagStr = String(tag).trim();
          const matchingLabel = allLabels.find(function (l) {
            const line = String(l).trim();
            if (!line || !tagStr) return false;
            const labelText = line.split(':')[0].trim();
            return (
              line.indexOf(tagStr) > -1 ||
              (labelText.length > 0 && tagStr.indexOf(labelText) > -1)
            );
          });
          if (matchingLabel || tagStr.indexOf('_label_') > -1) {
            const line = matchingLabel ? String(matchingLabel).trim() : '';
            const color =
              line.indexOf(':') > -1 ? line.split(':').slice(1).join(':').trim() : null;
            const tagKey = tagStr.split(':')[0];
            const colorStyle =
              color && color.length > 0 ? ` style="background-color: ${color}"` : '';
            return `
            <div class="grid-product__tag grid-product__tag--custom"${colorStyle}>${tagKey.replace('_label_', '')}</div>`;
          }
          return '';
        })
        .filter(function (t) {
          return t !== '';
        })
        .join('');

      const priceMain = product.price_varies
        ? priceFromTpl.split('__PRICE__').join(formatCents(product.price_min))
        : formatCents(product.price);

      let quickShopMarkup = '';
      if (theme.settings.quickView) {
        const quickLabel = theme.settings.quickShopText || 'Quick view';
        quickShopMarkup = `
            <div class="product__actions">
              <div class="quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-${product.id} small--hide">
                <span class="quick-product__label">${quickLabel}</span>
              </div>
              <span class="shopify-product-reviews-badge" data-id="${product.id}"></span>
            </div>`;
      } else {
        quickShopMarkup = `<span class="shopify-product-reviews-badge" data-id="${product.id}"></span>`;
      }

      const tagsMarkup = tags.length
        ? `<div class="grid-product__tags-container">${tags}</div>`
        : '';
      const saleCompareMarkup =
        product.compare_at_price > product.price ? comparePrice : '';

      output += `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}" data-product-handle="${product.handle}" data-product-id="${product.id}">
          <div class="grid-product__content">
            ${tagsMarkup}
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
                <div class="grid-product__price">
                  ${saleCompareMarkup}
                  ${priceMain}
                  ${quickShopMarkup}
                </div>
              </div>
            </a>
            ${form}
          </div>
        </div>`;
    });

    return output;
  };
})();
